module.exports = __webpack_public_path__ + "assets/img/TabBar_Contacts.0eaed262.svg";